import './index.css'
import clsx from 'clsx'

import React, { useState } from 'react'
import watermarkingSplashImage from 'assets/images/watermarking-splash@2x.png'
import Button from 'components/ui/button'
import Icon from 'components/ui/icon'
import Spinner from 'components/ui/spinner'
const plansData = [
  {
    quotaPlans: '1 Watermarked',
    label: 'Playlist',
    cost: 29,
    description: 'One playlist can be watermarked on your account at a time.',
  },
  {
    quotaPlans: '3 Watermarked',
    label: 'Playlists',
    cost: 69,
    description:
      'Three playlists can be watermarked on your account at a time.',
  },
  {
    quotaPlans: 'Unlimited Watermarked',
    label: 'Playlists',
    cost: 129,
    description: (
      <>
        Watermark as many playlists <br /> as you like.
      </>
    ),
  },
]

const Plan = ({ quotaPlans, label, cost, description }) => {
  return (
    <div className="WatermarkingSplash_Plan">
      <div className="WatermarkingSplash_PlanTitle">
        <div className="WatermarkingSplash_PlanBadge">{quotaPlans}</div>
        <span>{label}</span>
      </div>
      <div className="WatermarkingSplash_PlanPriceContainer">
        $<span className="WatermarkingSplash_PlanPrice">{cost}</span>/month
      </div>
      <p className="WatermarkingSplash_PlanDescription">{description}</p>
    </div>
  )
}

const WatermarkingSplash = (): React.ReactElement<'div'> => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const requestEarlyAccessButton = (
    <div className="WatermarkingSplash_ButtonContainer">
      <div>
        <Button
          link="/settings/billing"
          appearance="primary"
          caption="Subscribe to Watermarking"
        />
      </div>
    </div>
  )
  return (
    <div className="WatermarkingSplash">
      {!imageLoaded ? <Spinner /> : null}
      <div
        className={clsx('WatermarkingSplash_Content', {
          'WatermarkingSplash_Content--Hidden': !imageLoaded,
        })}
      >
        <section className="WatermarkingSplash_WatermarkingSection">
          <Icon type="watermarking-logo" className="WatermarkingSplash_Logo" />
          <h2 className="WatermarkingSplash_Title--Main">Watermarking</h2>
          <p className="WatermarkingSplash_Description--Main">
            Protect your files with ease with DISCO Watermarking. Secure,
            simple, and easy to use. Now all your team can work in the same
            place.
          </p>
          {requestEarlyAccessButton}
          <img
            className="WatermarkingSplash_Image"
            src={watermarkingSplashImage}
            onLoad={() => setImageLoaded(true)}
          />
        </section>

        <section className="WatermarkingSplash_PlansAndPricingSection">
          <h2 className="WatermarkingSplash_Title">Plans & pricing</h2>
          <p className="WatermarkingSplash_Description">
            Watermarking is charged in addition to your regular subscription.
            Watermarking subscriptions can be purchased monthly or annually.
          </p>
          <div className="WatermarkingSplash_PlansContainer">
            {plansData.map(planProps => (
              <Plan {...planProps} key={planProps.quotaPlans} />
            ))}
          </div>
          {requestEarlyAccessButton}
        </section>

        <section className="WatermarkingSplash_FAQSection">
          <h2 className="WatermarkingSplash_Title">FAQ</h2>

          <h3 className="WatermarkingSplash_SubTitle">
            Is watermarking included in any of your regular base plans?
          </h3>
          <p className="WatermarkingSplash_FAQDescription">
            No, watermarking is only offered as a paid add on.
          </p>

          <h3 className="WatermarkingSplash_SubTitle">
            How secure is your watermarking solution?
          </h3>
          <p className="WatermarkingSplash_FAQDescription">
            DISCO’s watermarking is very secure. The watermarking information
            encoded onto the watermarked file can survive re-encoding and
            alteration of the file.
          </p>

          <p className="WatermarkingSplash_FAQFooter">
            For more on how DISCO watermarking works,{' '}
            <a
              className="WatermarkingSplash_Link"
              href="https://support.disco.ac/home/watermarking-guide#faq"
              target="_blank"
              rel="noopener noreferrer"
            >
              check out our full FAQ.
            </a>
          </p>
        </section>
      </div>
    </div>
  )
}

export default WatermarkingSplash
